import type { BreakpointsOptions } from '@mui/material/styles';

/**
 * Breakpoints per spec §3 — slightly tighter than MUI defaults to align with
 * tablet (sm/md) and desktop (lg/xl) breakpoints the marketing site uses.
 */
export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 0,
    sm: 640,
    md: 900,
    lg: 1200,
    xl: 1440,
  },
};
